import React from 'react';
import DownloadLink from '../DownloadLink';

import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default function CanceledActions({ eventItem }) {
  if (!eventItem.completedAt) {
    return null;
  }

  return <div>
    <OverlayTrigger placement="top" overlay={<Tooltip>View</Tooltip>} >
      <Link className="btn btn-outline-primary btn-sm" to={`/forms/${eventItem.id}/view`}><i className="fa fa-list-alt"></i></Link>
    </OverlayTrigger>
    &nbsp;
    <DownloadLink eventItem={eventItem} small />
  </div>
}